import {Recherche} from './Recherche.js';
import {SuggestionCatégories, Suggestions} from "./Suggestions.js";

export class GestionnaireSuggestions {
    constructor(constructeurDeRecherche) {
        this.cr = constructeurDeRecherche;
        this.suggestions = []; // liste de Recherche
        this.conteneur = document.getElementById("suggestionsRecherche-MEQ-contenu");
        if (this.conteneur) {
            this.afficheSuggestions();
        }
    }

    afficheSuggestions() {

        this.conteneur.innerText = null;

        Object.keys(SuggestionCatégories)
            .forEach(codeCatégorie => {

                if (SuggestionCatégories[codeCatégorie].affiche) {

                    const divCat = document.createElement("div");
                    this.conteneur.append(divCat);

                    const titreCatÉlément = document.createElement("h4");
                    titreCatÉlément.innerText = SuggestionCatégories[codeCatégorie].nom;

                    divCat.appendChild(titreCatÉlément)

                    this.afficheSuggestionsCatégorie(codeCatégorie, divCat);
                }

            })


    }

    afficheSuggestionsCatégorie(codeCatégorie, divCat) {

        let suggestionsUL = document.createElement("ul")

        Suggestions[codeCatégorie]
            .forEach(suggestion => {
                let suggestionLI = document.createElement("li")
                let suggestionA = document.createElement("a")
                suggestionA.innerHTML = suggestion.nom;
                suggestionA.addEventListener("click", (e) => this.chargerSuggestion(suggestion));
                suggestionLI.appendChild(suggestionA);
                suggestionsUL.appendChild(suggestionLI);
            })

        divCat.appendChild(suggestionsUL);
    }

    chargerSuggestion(suggestion) {
        if (suggestion) {
            const recherche = new Recherche(suggestion.critères, suggestion.options, suggestion.nom);
            // Converti la suggestion ("recherche sérialisée") en recherche
            // Un stringify "pour rien" mais permet d'éviter répétition de code ;-)
            let r = Recherche.désérialise(JSON.stringify(recherche), this.cr)
            this.cr.chargeNouvelleRecherche(r);
        }
    }


}
